<sui-dialog-tabs class="no-aside-padding">
  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h5 ngpDialogDescription>{{ objectNameTitle }}</h5>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <div class="wizard">
      <div class="steps">
        <app-wizard-steps
          [steps]="wizardSteps"
          [currentStep]="currentStep"
        ></app-wizard-steps>
      </div>
      <div class="wizard-step">
        <ng-container #tabHost></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template suiDialogRightFooter>
    <div class="right-footer-wrapper">
      @for (button of buttons; track button.text) {
        <sui-button
          [variant]="button.variant || 'secondary'"
          [size]="button.size || 'md'"
          [leadingIcon]="button.leadingIcon"
          (click)="button.action()"
          [disabled]="button.disabled || false"
          [loading]="button.loading || false"
        >
          {{ button.text }}
        </sui-button>
      }
    </div>
  </ng-template>
</sui-dialog-tabs>
